import React, { createContext, forwardRef, useContext, useState } from 'react'
import { TabButton, TabComponent } from './styles'

// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
const TabContext = createContext({ selectedIndex: 0, setSelectedIndex: (idx: number) => {} })

const Tabs = ({ children }: { children: React.ReactNode }) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  return (
    <TabContext.Provider value={{ selectedIndex, setSelectedIndex }}>
      <>{children}</>
    </TabContext.Provider>
  )
}

type TabProps = {
  index?: number
  children: React.ReactNode
} & React.ButtonHTMLAttributes<HTMLButtonElement>

// eslint-disable-next-line react/prop-types
export const Tab = forwardRef<HTMLButtonElement, TabProps>(({ index, children, onClick, ...props }: TabProps, ref) => {
  const { selectedIndex, setSelectedIndex } = useContext(TabContext)

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick) {
      onClick(e)
    }
    setSelectedIndex(index ?? 0)
  }

  return (
    <TabButton
      active={selectedIndex === index}
      onClick={(e) => {
        handleClick(e)
      }}
      ref={ref}
      {...props}
    >
      {children}
    </TabButton>
  )
})

const isTabComponent = (component: React.ReactNode): component is React.ReactElement<typeof Tab> => {
  return React.isValidElement(component) && component.type === Tab
}
const TabList = ({ children }: { children: React.ReactNode }) => {
  return (
    <TabComponent>
      {React.Children.map(children, (child, index) => {
        console.log(React.isValidElement(child), React.isValidElement(child) && child.type === Tab)
        if (!isTabComponent(child)) {
          throw Error('TabList Children is Not a Tab Components')
        }
        const newProps = {
          index,
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return React.cloneElement(child, newProps)
      })}
    </TabComponent>
  )
}

const TabPanel = ({ children }: { children: React.ReactNode }) => {
  return <div>{children}</div>
}

const isTabPanelComponent = (component: React.ReactNode): component is React.ReactElement<typeof TabPanel> => {
  return React.isValidElement(component) && component.type === TabPanel
}

const TabPanels = ({ children }: { children: React.ReactNode }) => {
  const { selectedIndex } = useContext(TabContext)
  const selectedComponent = React.Children.toArray(children).filter((child) => isTabPanelComponent(child))[
    selectedIndex
  ]
  return <>{selectedComponent}</>
}

Tabs.TabList = TabList
Tabs.Tab = Tab
Tabs.TabPanels = TabPanels
Tabs.TabPanel = TabPanel

export default Tabs
